import { render, staticRenderFns } from "./status-message.vue?vue&type=template&id=90fe5c9e"
import script from "./status-message.vue?vue&type=script&lang=js"
export * from "./status-message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports